import PropTypes from 'prop-types';
import React from 'react';
import './buttons.css';

export const Button = ({ primary, icon, block, backgroundColor, size, label, ...props }) => {
  const mode = primary ? 'vivace-button--primary' : 'vivace-button--raised';
  const isblock = block ? 'block' : '';
  return (
    <button
      //aria-block={isblock}
      type="button"
      className={[`vivace-button ${isblock}`, `vivace-button--${size} ${isblock}`, mode].join(' ')}
      style={backgroundColor && { backgroundColor }}
      {...props}
    >
      <span>
        {icon ? <i className={`${icon}`}></i> : ''}
        {label}
      </span>
    </button>
  );
};

Button.propTypes = {
  icon: PropTypes.string,
  block: PropTypes.bool,
  primary: PropTypes.bool,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  backgroundColor: null,
  primary: false,
  size: 'medium',
  onClick: () => {},
  block: false,
};



// WEBPACK FOOTER //
// ./src/componentes/buttons/index.jsx